import { QubesUserGroup } from "../model/qubes-user-group";
export class QubesUser{
    public id:number;
    public userName:string;
    public email:string;
    public password?:string;
    public isActive?:string;
    public name?:string="";
    public designation?:string ="";
    public userLevel?:string;
    public environmentAccess: Array<QubesEnvironmentAccess>;
    public userDetails?:Array<QubesUserDetail>;
    public organisationId?:number=1;
    public applicationId?:number= 1;
    public menuMappingGroupMasterPriority?:number;
    public menuMappingGroupName?:string;
    public menuMappingGroupPriority?:number;
    public mohUserId ?: string; 
    public isLogin ?: string; 

   
}

export class QubesEnvironmentAccess {
    id!: number;
    userId!: number;
    qubesDev: boolean;
    qubesUat: boolean;
    qubesProd: boolean;
}

export class QubesUserDetail{
    public id:number;
    public userGroupId:number;
    public userLevel:string;
    public stateNames?:string;
    
    public clinicCategoryIds : Array<any>;
    public stateIds:Array<any>;
    public circleIds:Array<any>;
    public districtIds:Array<any>;
    public clinicIds:Array<any>;
    public clinicCategoryId:string;
    public stateId:string;
    public circleId:string;
    public districtId:string;
    public clinicId:string;
    public userGroupPriority:number;
    public userGroupMasterPriority:number;
    public userGroupCode:string;
    public userGroupName:string;
    public userGroups:Array<QubesUserGroup>;
}